import AdvanceManualRepayment from 'features/advance/screens/advanceManualRepay/AdvanceManualRepayment/AdvanceManualRepayment';
import React from 'react';

export default function AdvanceManualRepaymentPage() {
  return <AdvanceManualRepayment />;
}
